const closeMenu = (toggle, panel) => {
    toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.hidden = true;
    panel.classList.remove('is-open');
};

const openMenu = (toggle, panel) => {
    toggle.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.hidden = false;
    panel.classList.add('is-open');
};

export const initInstructionalContentBlocks = (root = document) => {
    const blocks = root.querySelectorAll('.instructional-content-block:not([data-icb-bound])');

    blocks.forEach((block) => {
        block.dataset.icbBound = 'true';

        const toggle = block.querySelector('[data-icb-toggle]');
        if (!toggle) return;

        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel || !block.contains(panel)) return;

        closeMenu(toggle, panel);

        toggle.addEventListener('click', () => {
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
                closeMenu(toggle, panel);
                return;
            }

            openMenu(toggle, panel);
        });

        panel.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => closeMenu(toggle, panel));
        });

        block.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
                closeMenu(toggle, panel);
                toggle.focus();
            }
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstructionalContentBlocks);
} else {
    initInstructionalContentBlocks();
}
